import { render, staticRenderFns } from "./CTable.vue?vue&type=template&id=17e0600e&"
import script from "./CTable.vue?vue&type=script&lang=js&"
export * from "./CTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports